module.exports = __webpack_public_path__ + "img/bobodo_bobocoin.gm.9d79685.png";